import { createSlice } from '@reduxjs/toolkit';

import * as Status from 'constants/statuses';

import { userSignout } from 'dux/auth/actions';

import initialState from './initialState';
import { fetchMembership, setSelectedProduct } from './thunks';

const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // reinitialize state upon signout
      .addCase(userSignout, () => initialState)

      .addCase(fetchMembership.pending, draft => {
        draft.status = Status.LOADING;
      })
      .addCase(fetchMembership.fulfilled, (draft, { payload }) => {
        draft.status = Status.SUCCESS;
        draft.memberSince = payload.member_since;
        draft.numberOfProductBoughtSinceLastUnlock =
          payload.number_of_product_bought_since_last_unlock;
        draft.numberOfPendingSelectionProducts = payload.number_of_pending_selection_products;
        draft.currentSelectedFreeProduct = payload.current_selected_free_product;
        draft.freeProductCatalog = payload.free_product_catalog;
      })
      .addCase(fetchMembership.rejected, draft => {
        draft.status = Status.ERROR;
      })
      .addCase(setSelectedProduct.pending, draft => {
        draft.status = Status.LOADING;
      })
      .addCase(setSelectedProduct.fulfilled, (draft, { payload }) => {
        draft.status = Status.SUCCESS;
        draft.currentSelectedFreeProduct = payload.current_selected_free_product;
      })
      .addCase(setSelectedProduct.rejected, draft => {
        draft.status = Status.ERROR;
      });
  },
});

export const { reducer } = membershipSlice;
